import React from "react";
import {Users} from '../../../components/Filters'

export default (props: any) => {
  const {users} = props.modalProps;
  return <Users name="users"
                defaultSelected={users}
                maxTagCount={10} />
}